import HttpService from '../../../core/rest/http.service';
export async function loadOfficialBoardRecords(filter) {
    let parameters = {};
    parameters = {
        q: filter.query,
        oblast: filter.fieldId || undefined,
        kategorie: filter.categoryId || undefined,
        archived: filter.archiveIncluded || undefined,
        groupId: filter.groupId,
        showSiteUrl: filter.showSiteUrl,
        page: filter.pager.page,
        pageSize: filter.pager.perPage,
    };
    Object.entries(parameters).forEach(([key, value]) => {
        if (value === undefined)
            delete parameters[key];
    });
    const endpoint = "/search/mc/uredni-deska";
    return HttpService.get(endpoint, parameters);
}
export async function loadCategories(params) {
    let parameters = {};
    parameters = {
        groupId: params.groupId || undefined,
        archived: params.archived || undefined,
    };
    Object.entries(parameters).forEach(([key, value]) => {
        if (value === undefined)
            delete parameters[key];
    });
    const endpoint = "/search/mc/uredni-deska/kategorie";
    return HttpService.get(endpoint, parameters);
}
